module.exports = __webpack_public_path__ + "img/profile_img2.80cf069a.jpg";